module.exports = __webpack_public_path__ + "static/media/southern-cross.111e072d.png";